import styles from "@styles/containers/oraculo/customer-drawer/data-tab.module.scss";

import { Currency } from "@utils/Currency";

import classNames from "classnames/bind";
import { Numbers } from "shared/utils/Numbers";
const css = classNames.bind(styles);

export default function ({ customer }) {
  if (!customer?.rfv) {
    return null;
  }

  const {
    order_recency: recency,
    order_frequency: frequency,
    order_value: value,
  } = customer.rfv;

  return (
    <div className={styles.rfv}>
      <Bar
        label={"Recência"}
        percentage={recency?.recency}
        sticks={[
          recency?.bad_max,
          recency?.bad_average,
          recency?.good_average,
          0,
        ]}
        value={
          <>
            {Math.abs(recency?.recency) || 0}&nbsp;<span>dias</span>
          </>
        }
        customer={customer}
      />
      <Bar
        label={"Frequência"}
        percentage={frequency?.frequency}
        sticks={[
          frequency?.bad_max,
          frequency?.bad_average,
          frequency?.good_average,
          0,
        ]}
        value={
          <>
            {Math.abs(frequency?.frequency) || 0}&nbsp;<span>dias</span>
          </>
        }
        customer={customer}
      />
      <Bar
        label={"Valor"}
        percentage={value?.value}
        sticks={[0, value?.bad_average, value?.good_average, value?.good_max]}
        value={Currency.formatCurrency(Math.abs(value?.value))}
        customer={customer}
      />
    </div>
  );
}

const Bar = ({ label, sticks = [], value, percentage, customer }) => {
  const _0 = Math.min(...sticks);
  const _100 = Math.max(...sticks);
  const _range = _100 - _0;

  const percentage_sticks = [];

  if (Number.isNaN(_range) || !_range) {
    return null;
  }

  percentage_sticks.push(
    ...sticks.map((v) => Math.abs(((v - _0) / _range) * 100))
  );

  const _percentage = Math.abs(((percentage - _0) / _range) * 100);

  const empty = Numbers.formatInt(customer.count_orders || 0) < 3;

  return (
    <div
      className={css({
        indicator: true,
        empty: empty,
      })}
    >
      <div className="d-flex align-center justify-between">
        <span className={styles.label}>{label}</span>
        {empty ? (
          <p className={styles.value}>---</p>
        ) : (
          <p className={styles.value}>{value}</p>
        )}
      </div>

      <div className={styles.bar}>
        <div className={styles.roundTicks}>
          {Array.from({ length: 30 }).map(() => (
            <div className={styles.tick} style={{ opacity: 0.3 }} />
          ))}
          <div
            className={styles.opacity}
            style={{
              background: `linear-gradient(to right, rgba(41, 46, 51, 0) ${_percentage}%, transparent ${_percentage}%`,
            }}
          />
        </div>

        <div className={styles.line}>
          <div className={styles.lineTicks}>
            {percentage_sticks.map((p) => (
              <div
                className={styles.tick}
                style={{ position: "absolute", left: `${p}%` }}
              />
            ))}
          </div>

          <span className={styles.pointer} style={{ width: `${_percentage}%` }}>
            <i className="fas fa-location-dot" />
          </span>
        </div>
      </div>
    </div>
  );
};
